/* Enrichment lives on its own page.
 *
 * lesson-structure.md rates extra information "actively risky" for novices and
 * is explicit that sequential placement at the end of the lesson does not
 * neutralise it. So it is a separate route, labelled, and never in the assessed
 * scope. The link back is prominent because returning is the expected move.
 *
 * It uses the reader's act layout rather than a layout of its own. An earlier
 * version reached for `.article` and a grid template, both of which were
 * removed when the reader was rebuilt as full-bleed acts — leaving this page
 * rendering unstyled. Sharing the acts means it cannot drift again.
 */

import s from './LessonReader.module.css';
import { RuleRow, Button, Block } from '../design/primitives.jsx';
import { Blocks } from './LessonBody.jsx';

export default function Enrichment({ lesson, extra, onBack }) {
  return (
    <div className={s.reader}>
      <header className={s.head}>
        <RuleRow kicker="Going further · not assessed" meta="optional" />
        <h1 className={s.title}>{extra?.title || `${lesson.title} — going further`}</h1>
      </header>

      <section className={s.act}>
        <div className={s.actInner}>
          {extra
            ? <div className={s.grid}><div><Blocks blocks={extra.body} /></div></div>
            : <Block kind="notice">Nothing here yet.</Block>}

          <div className={s.foot}>
            <button type="button" className={s.prev} onClick={onBack}>
              ← Back to {lesson.title}
            </button>
            <div className={s.footActions}>
              <Button onClick={onBack}>Back to the lesson</Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
